import { render, staticRenderFns } from "./WordAreaView.vue?vue&type=template&id=3fb2e2b6&scoped=true&"
import script from "./WordAreaView.vue?vue&type=script&lang=js&"
export * from "./WordAreaView.vue?vue&type=script&lang=js&"
import style0 from "./WordAreaView.vue?vue&type=style&index=0&id=3fb2e2b6&scoped=true&lang=scss&"
import style1 from "./WordAreaView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2e2b6",
  null
  
)

export default component.exports